/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AllTagsNotExistCondition } from '../models/all-tags-not-exist-condition';
import { AlwaysTrueCondition } from '../models/always-true-condition';
import { AnyTagExistsCondition } from '../models/any-tag-exists-condition';
import { AnyTagIsEmptyCondition } from '../models/any-tag-is-empty-condition';
import { AnyTagIsNotEmptyCondition } from '../models/any-tag-is-not-empty-condition';
import { ComparingLongCondition } from '../models/comparing-long-condition';
import { ConditionGroup } from '../models/condition-group';
import { ContainsAllStringsCondition } from '../models/contains-all-strings-condition';
import { ContainsAllStringsNearbyCondition } from '../models/contains-all-strings-nearby-condition';
import { ContainsAnyStringCondition } from '../models/contains-any-string-condition';
import { DocumentAssignedToMagnetCondition } from '../models/document-assigned-to-magnet-condition';
import { DocumentIsStampedCondition } from '../models/document-is-stamped-condition';
import { documentSearchGetCondition } from '../fn/document-search/document-search-get-condition';
import { DocumentSearchGetCondition$Params } from '../fn/document-search/document-search-get-condition';
import { documentSearchGetList } from '../fn/document-search/document-search-get-list';
import { DocumentSearchGetList$Params } from '../fn/document-search/document-search-get-list';
import { DocumentSearchList } from '../models/document-search-list';
import { FixedRangeDateTimeCondition } from '../models/fixed-range-date-time-condition';
import { FixedRangeLongCondition } from '../models/fixed-range-long-condition';
import { FutureDateTimeCondition } from '../models/future-date-time-condition';
import { GreaterThanOrEqualDateTimeCondition } from '../models/greater-than-or-equal-date-time-condition';
import { LessThanOrEqualDateTimeCondition } from '../models/less-than-or-equal-date-time-condition';
import { PastDateTimeCondition } from '../models/past-date-time-condition';
import { SelectionContainsAllIdsCondition } from '../models/selection-contains-all-ids-condition';
import { SelectionContainsAnyIdCondition } from '../models/selection-contains-any-id-condition';
import { SelectionEqualsCondition } from '../models/selection-equals-condition';
import { StartsWithAnyStringCondition } from '../models/starts-with-any-string-condition';
import { StringEqualsCondition } from '../models/string-equals-condition';

@Injectable({ providedIn: 'root' })
export class DocumentSearchService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentSearchGetCondition()` */
  static readonly DocumentSearchGetConditionPath = '/document-search/{searchId}/condition';

  /**
   * Get document search condition.
   *
   * Get document search condition
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentSearchGetCondition()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentSearchGetCondition$Response(params: DocumentSearchGetCondition$Params, context?: HttpContext): Observable<StrictHttpResponse<(AllTagsNotExistCondition | AlwaysTrueCondition | AnyTagExistsCondition | AnyTagIsEmptyCondition | AnyTagIsNotEmptyCondition | ComparingLongCondition | ConditionGroup | ContainsAllStringsCondition | ContainsAllStringsNearbyCondition | ContainsAnyStringCondition | DocumentAssignedToMagnetCondition | DocumentIsStampedCondition | FixedRangeDateTimeCondition | FixedRangeLongCondition | FutureDateTimeCondition | GreaterThanOrEqualDateTimeCondition | LessThanOrEqualDateTimeCondition | PastDateTimeCondition | SelectionContainsAllIdsCondition | SelectionContainsAnyIdCondition | SelectionEqualsCondition | StartsWithAnyStringCondition | StringEqualsCondition)>> {
    const obs = documentSearchGetCondition(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get document search condition.
   *
   * Get document search condition
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentSearchGetCondition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentSearchGetCondition(params: DocumentSearchGetCondition$Params, context?: HttpContext): Observable<(AllTagsNotExistCondition | AlwaysTrueCondition | AnyTagExistsCondition | AnyTagIsEmptyCondition | AnyTagIsNotEmptyCondition | ComparingLongCondition | ConditionGroup | ContainsAllStringsCondition | ContainsAllStringsNearbyCondition | ContainsAnyStringCondition | DocumentAssignedToMagnetCondition | DocumentIsStampedCondition | FixedRangeDateTimeCondition | FixedRangeLongCondition | FutureDateTimeCondition | GreaterThanOrEqualDateTimeCondition | LessThanOrEqualDateTimeCondition | PastDateTimeCondition | SelectionContainsAllIdsCondition | SelectionContainsAnyIdCondition | SelectionEqualsCondition | StartsWithAnyStringCondition | StringEqualsCondition)> {
    const resp = this.documentSearchGetCondition$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<(AllTagsNotExistCondition | AlwaysTrueCondition | AnyTagExistsCondition | AnyTagIsEmptyCondition | AnyTagIsNotEmptyCondition | ComparingLongCondition | ConditionGroup | ContainsAllStringsCondition | ContainsAllStringsNearbyCondition | ContainsAnyStringCondition | DocumentAssignedToMagnetCondition | DocumentIsStampedCondition | FixedRangeDateTimeCondition | FixedRangeLongCondition | FutureDateTimeCondition | GreaterThanOrEqualDateTimeCondition | LessThanOrEqualDateTimeCondition | PastDateTimeCondition | SelectionContainsAllIdsCondition | SelectionContainsAnyIdCondition | SelectionEqualsCondition | StartsWithAnyStringCondition | StringEqualsCondition)>): (AllTagsNotExistCondition | AlwaysTrueCondition | AnyTagExistsCondition | AnyTagIsEmptyCondition | AnyTagIsNotEmptyCondition | ComparingLongCondition | ConditionGroup | ContainsAllStringsCondition | ContainsAllStringsNearbyCondition | ContainsAnyStringCondition | DocumentAssignedToMagnetCondition | DocumentIsStampedCondition | FixedRangeDateTimeCondition | FixedRangeLongCondition | FutureDateTimeCondition | GreaterThanOrEqualDateTimeCondition | LessThanOrEqualDateTimeCondition | PastDateTimeCondition | SelectionContainsAllIdsCondition | SelectionContainsAnyIdCondition | SelectionEqualsCondition | StartsWithAnyStringCondition | StringEqualsCondition) => r.body)
    );
  }

  /** Path part for operation `documentSearchGetList()` */
  static readonly DocumentSearchGetListPath = '/document-search/{searchId}/list';

  /**
   * Get found documents.
   *
   * Get found documents
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentSearchGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentSearchGetList$Response(params: DocumentSearchGetList$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentSearchList>> {
    const obs = documentSearchGetList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get found documents.
   *
   * Get found documents
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentSearchGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentSearchGetList(params: DocumentSearchGetList$Params, context?: HttpContext): Observable<DocumentSearchList> {
    const resp = this.documentSearchGetList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DocumentSearchList>): DocumentSearchList => r.body)
    );
  }

}
